import React, { Component, Fragment } from 'react';
import { shape, number, string, bool, func, object, objectOf, arrayOf, any, element } from 'prop-types';
import { advertiserShape } from '../../../helpers/propTypes';
import { get } from 'lodash';
import { FormControl, Select, MenuItem, MuiThemeProvider } from '@material-ui/core';
import { AvTimer, Info as InfoIcon } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import { withStyles, createTheme } from '@material-ui/core/styles';
import CreativeTable from './CreativeTable';
import CreativeChart from './CreativeChart';
import ModuleExport from '../../../components/ModuleExport';
import ShowAllAds from 'components/Modal/ShowAllAds';
import { 
  TYPE_LIVE_READ, 
  TYPE_PRE_RECORDED, 
  TYPE_WATCHLIST, 
  CREATIVE_CHART_ID, 
  CREATIVE_CHART_FILE_NAME 
} from './constants';
import styles from './styles.scss';
import cx from 'classnames';
import {
  SINGLE_PAGE_WEB_ANALYTICS_DATA,
  MIN_LENGTH_CREATIVE_DATA,
  STATUS_ENGINE_ERROR,
  AD_TYPE_ID,
  COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE,
  CREATIVE_TYPE_OPTIONS,
  newAdUsersKey,
  newAdUsersMetricKey,
  newAdUsersPerAdsKey,
} from '../../../helpers/constant';
import { ADSICON_TOOLTIP_TEXT } from '../constants';
import { formatCreativeChartData } from '../../../helpers/formatData';
import { defaultChartSelector } from '../../../helpers/defaultInfo';
import DeleteReportItemButton from '../../DeleteReportItem';
import { NewAdUserSunsetDisclaimer } from '../ChartDisclaimer';
const defaultDataType = get(defaultChartSelector, [CREATIVE_CHART_ID, 'dataType']);
const defaultCategoryType = get(defaultChartSelector, [CREATIVE_CHART_ID, 'categoryType']);
import { getNumberOfChartAndTableInReport } from '../Report/helper';

const customStyles = createTheme({
  overrides: {
    MuiSelect: {
      selectMenu: {
        textOverflow: "clip",
      }
    }
  }
})

export class CreativeAnalytics extends Component {
  static propTypes = {
    title: string,
    data: arrayOf(shape({
      creative_duration: string,
      creative_name: string,
      station_name: arrayOf(string),
      type_name: string,
      type_id: number,
      visitOfads: number,
      visits: number,
      aired: number,
      avgAdCost: number,
      adUser: number,
    })),
    advertiser: advertiserShape.isRequired,
    campaign: shape({
      chartData: object,
      campaign_id: number
    }),
    inpdf: bool,
    classes: shape({ any }),
    undoCreativeName: func,
    urlApi: objectOf(string),
    reProcessSaga: func,
    removeVisualRefreshDataSaga: func,
    currentData: arrayOf(shape({
      id: string,
      type: string,
      description1: string,
      description2: string
    })),
    redirectToCampaignTabs: func,
    currentPayload: shape({
      advertiserId: number,
      campaignId: number,
      tab: string
    }),
    typeOptions: shape({
      visitOfAds: shape({ value: string, label: string }),
      avgAdCost: shape({ value: string, label: string }),
      adVisit: shape({ value: string, label: string }),
      adUser: shape({ value: string, label: string }),
      creativeName: shape({ value: string, label: string, icon: element }),
      creativeDuration: shape({ value: string, label: string, icon: element }),
      newAdUsers: shape({ value: string, label: string }),
    }),
    isAvgCostDisabled: bool,
    page: number,
    numberPage: number,
    selectedDataType: string,
    selectedCategoryType: string,
    isCustomReport: bool,
    showInReportConfig: shape({
      creativeChart: bool,
      creativeTable: bool,
    }),
    countInReportConfig: shape({
      creativeChart: arrayOf(number),
      creativeTable: arrayOf(number),
    }),
    setChartSelector: func,
    setReportChartSelector: func,
    currentStep: string,
    setTableSortStatus: func,
    creativeChartSelectors: arrayOf(objectOf(string)),
    tableSortSelectors: shape(objectOf({
      sortKey: string,
      sortType: string
    })),
    enabledFlags: arrayOf(string),
    isHiddenChart: bool,
    isTableOnly: bool,
    rowOnFirstPage: number
  };

  static defaultProps = {
    title: 'Creative',
    typeOptions: {
      ...CREATIVE_TYPE_OPTIONS,
      creative_name: {
        value: 'creative_name',
        label: 'By Creative',
        icon: <i className={cx('icon-station-playout', styles.stationIcon)} />
      },
      creative_duration: {
        value: 'creative_duration',
        label: 'By Duration',
        icon: <AvTimer className={styles.durationIcon} />
      }
    },
    showInReportConfig: {},
    countInReportConfig: {
      creativeChart: [1],
      creativeTable: [1],
    },
    campaign: {}
  }

  state = {
    isDrillDownOpen: false
  };

  componentDidMount() {
    const { campaign, undoCreativeName } = this.props
    !!campaign && undoCreativeName(campaign.campaign_id, false)
  }

  componentWillUnmount() {
    const { undoCreativeName, campaign } = this.props
    !!campaign && undoCreativeName(campaign.campaign_id, false)
  }

  handleDrillDownClose = () => {
    const { currentPayload, redirectToCampaignTabs } = this.props;
    const { campaignId, advertiserId, tab } = currentPayload;
    redirectToCampaignTabs(advertiserId, campaignId, tab);
    this.setState({
      isDrillDownOpen: false,
      summaryDrillDownInfo: {},
    });
  }

  handleCellClick = (data) => {
    const { adTypeId, creativeName, duration } = data;
    const { urlApi, campaign, isCustomReport } = this.props;
    if (isCustomReport) {
      return;
    }
    let adType;

    switch (adTypeId) {
      case TYPE_WATCHLIST.id:
        adType = TYPE_WATCHLIST.name;
        break;
      case TYPE_LIVE_READ.id:
        adType = TYPE_LIVE_READ.name;
        break;
      default:
        adType = TYPE_PRE_RECORDED.name;
    }

    const creativeDuration = creativeName === TYPE_LIVE_READ.name ? '' : duration;
    const drillDownCreativeName = creativeName === TYPE_LIVE_READ.name ? '' : creativeName;

    const summaryDrillDownUrl = {
      urlApi,
      campaignId: campaign.campaign_id,
      adType,
      creativeDuration,
      creativeName: drillDownCreativeName
    }
    this.setState({
      isDrillDownOpen: true,
      summaryDrillDownUrl,
      summaryDrillDownInfo: { ...summaryDrillDownUrl }
    });
  }

  onActionClick = data => event => {
    const { reProcessSaga } = this.props;
    reProcessSaga && reProcessSaga(data);
  }

  onRemoveClick = data => event => {
    const { removeVisualRefreshDataSaga } = this.props;
    removeVisualRefreshDataSaga && removeVisualRefreshDataSaga(data);
  }

  handleTypeChange = (index) => (e) => {
    const newType = e.target.value;
    this.handleSetChartSelector(index, { dataType: newType });
  }

  handleCategoryChange = (index) => (e) => {
    const newCategory = e.target.value;
    this.handleSetChartSelector(index, { categoryType: newCategory });
  }

  handleSetChartSelector = (index, selectorObj) => {
    const { setChartSelector, campaign, setReportChartSelector, isCustomReport } = this.props;
    const campaignId = campaign.campaign_id;
    setChartSelector && setChartSelector(campaignId, CREATIVE_CHART_ID, selectorObj);
    isCustomReport
    && setReportChartSelector
    && setReportChartSelector(CREATIVE_CHART_ID, index, selectorObj);
  }
  
  onTableSort = (sortStatus) =>{
    const { setTableSortStatus, campaign } = this.props;
    const campaignId = campaign.campaign_id;
    setTableSortStatus && setTableSortStatus(campaignId, CREATIVE_CHART_ID, sortStatus)
  }

  drawDataSelector = (index, dataTypeInCustomReport) => {
    const {
      typeOptions,
      classes,
      isAvgCostDisabled,
      selectedDataType,
      enabledFlags,
      advertiser, 
      campaign,
      reportBuilder,
      isCustomReport
    } = this.props;
    const { visitOfads, avgAdCost, visits, newAdUsers} = typeOptions;
    const customReportDateRange = get(reportBuilder, 'reportProperties.reportDateRange');
    const isNewAdUserSelectorShow = isCustomReport ?
                                    shouldShowTileByDateCompare({ advertiser, campaign, customReportDateRange}) :
                                    shouldShowTileByDateCompare({advertiser, campaign});
    const isNewAdUsersEnabled = checkEnableFeatureFlag(enabledFlags, [newAdUsersMetricKey]) && isNewAdUserSelectorShow;

    return (
      <MuiThemeProvider theme={customStyles}>
        <FormControl className={styles.dataDropDown}>
          <Select
            value={dataTypeInCustomReport || selectedDataType}
            className={styles.selector}
            onChange={this.handleTypeChange(index)}
            inputProps={{ classes: { icon: classes.arrowDropDown } }}
            data-test="selectDataType"
          >
            <MenuItem value={visitOfads.value} data-test="dataTypeVisitOfAds">{visitOfads.label}</MenuItem>
            {!isAvgCostDisabled && <MenuItem value={avgAdCost.value} data-test="dataTypeAvgAdCost">{avgAdCost.label}</MenuItem>}
            <MenuItem value={visits.value} data-test="dataTypeVisits">{visits.label}</MenuItem>
            {isNewAdUsersEnabled && <MenuItem value={newAdUsers.value} data-test="dataTypeNewAdUsers">{newAdUsers.label}</MenuItem>}
          </Select>
        </FormControl>
      </MuiThemeProvider>
    );
  }

  drawCategorySelector = (index, categoryTypeInCustomReport) => {
    const { typeOptions, classes, selectedCategoryType } = this.props;
    const { creative_name, creative_duration } = typeOptions;
    const categoryType = categoryTypeInCustomReport || selectedCategoryType;
    return (
      <FormControl className={styles.categoryDropDown}>
        <Select
          value={categoryType}
          className={styles.selector}
          onChange={this.handleCategoryChange(index)}
          inputProps={{ classes: { icon: classes.arrowDropDown } }}
          data-test="selectCategoryType"
          /* eslint-disable react/jsx-no-bind */
          // material-ui only accept this format of props
          renderValue={function () {
            return (
              <div className={styles.menuItem}>
                <span className={styles.icon}>{typeOptions[selectedCategoryType].icon}</span>
                <span data-test={"categoryTypeOption_" + typeOptions[categoryType].label}>{typeOptions[categoryType].label}</span>
              </div>
            )
          }}
        /*eslint-enable react/jsx-no-bind */
        >
          <MenuItem value={creative_name.value}>
            <span className={styles.creativeListIcon}>{creative_name.icon}</span>
            <span>{creative_name.label}</span>
          </MenuItem>
          <MenuItem value={creative_duration.value}>
            <span className={styles.creativeListIcon}>{creative_duration.icon}</span>
            <span>{creative_duration.label}</span>
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  handleAnalyzeMention = (mention) => {
    const {
      mention_name: mentionName,
      creative_name: creativeName,
      ads_type_id: adTypeId
    } = mention;
    const isPreRecorded = adTypeId === AD_TYPE_ID['Pre-recorded Spots'];
    return {
      ...mention,
      original_mention_name: mentionName,
      mention_name: isPreRecorded ? creativeName : mentionName
    }
  }

  scrollableChild = React.createRef();
  exportContainer = React.createRef();
  render() {
    const { 
      title, 
      data, 
      inpdf, 
      campaign, 
      advertiser, 
      currentData, 
      typeOptions, 
      page, 
      numberPage, 
      isAvgCostDisabled,
      selectedDataType,
      isCustomReport,
      showInReportConfig,
      countInReportConfig,
      selectedCategoryType,
      currentStep,
      creativeChartSelectors,
      tableSortSelectors,
      enabledFlags,
      isHiddenChart,
      isTableOnly,
      rowOnFirstPage,
    } = this.props;
    const {
      isDrillDownOpen,
      summaryDrillDownInfo,
      summaryDrillDownUrl
    } = this.state;

    const { creativeChart, creativeTable } = showInReportConfig;

    //TODO: check with Dat about what does this do
    const notifications = currentData && currentData.map(data => {
      return {
        ...data,
        onActionClick: data.status_engine === STATUS_ENGINE_ERROR ? this.onActionClick(data) : undefined,
        onRemoveClick: data.status_engine === STATUS_ENGINE_ERROR ? this.onRemoveClick(data) : undefined
      }
    });

    const isGrandTotalDisplay = !inpdf || inpdf && page === numberPage - 1;
    const isFirstPageInPdf = !inpdf || (inpdf && page === 0) && !isHiddenChart;
    let showCreativeChart = isFirstPageInPdf;
    let showCreativeTable = true;
    let showDeleteChartButton = false;
    let showDeleteTableButton = false;
    if (isCustomReport) {
      showCreativeChart = creativeChart && showCreativeChart;
      showDeleteChartButton = creativeChart;
      showCreativeTable = creativeTable;
      showDeleteTableButton = creativeTable;
    }
    const {
      creativeChart: chartCount,
      creativeTable: tableCount,
    } = countInReportConfig;
    const countForCustomReport = getNumberOfChartAndTableInReport(chartCount, tableCount);
    return (
      <Fragment>
        {Array(countForCustomReport).fill('').map((_item, index) => {
          const prefixKey = chartCount[index] ? 'creativeChart' : 'creativeTable'; 
          const key = prefixKey + (chartCount[index] || tableCount[index] || (index +1));
          const creativeChartId = chartCount.find(item => item === index +1);
          const isDisplayCreativeChartInPreview = !!creativeChartId && !isHiddenChart || isTableOnly;
          showCreativeChart = isFirstPageInPdf && isDisplayCreativeChartInPreview;
          showCreativeTable = !!tableCount.find(item => item === index + 1) && (inpdf ? isHiddenChart : true);
          const chartData = formatCreativeChartData(creativeChartSelectors[index], this.props);

          //access individual dropdown selections/values when adding multiple creative charts to custom report.
          // Don't use default here cause when we don't use multi-charts, it messes up the dataType when select other dataType
          // (Use defaultDataType instead of selectedDataType)
          const reportTypeSelector = get(creativeChartSelectors, [index, 'dataType']);
          const reportCategorySelector = get(creativeChartSelectors, [index, 'categoryType']);

          const chartSelectorDataType = reportTypeSelector || selectedDataType || defaultDataType;
          const chartSelectorCategory = reportCategorySelector || selectedCategoryType || defaultCategoryType;
          const isDuration = chartSelectorCategory == typeOptions.creative_duration.value;
          const isAvgAdCost = chartSelectorDataType == typeOptions.avgAdCost.value;
          const isAdVisit = chartSelectorDataType == typeOptions.visits.value;
          const isNewAdUserSelected = chartSelectorDataType == typeOptions.newAdUsers.value;
          const chartAxis = get(typeOptions, [chartSelectorDataType, 'label'], typeOptions.visitOfads.label);
          const isDisplayChartContainer = !inpdf && (showCreativeChart || showCreativeTable) || inpdf && showCreativeChart && !isHiddenChart;
          let rowsPerPage = 0;
          if (inpdf) {
            // show table rows on full pdf page and add one more row if this page doesn't display the Grand Total row 
            rowsPerPage = 25;
            
            // show fewer rows on the first page because of the chart above the table
            if ( page === 0 ) {
              let rowFirstPage =  rowOnFirstPage || MIN_LENGTH_CREATIVE_DATA;
              rowsPerPage = rowFirstPage + 1
            }
            
          }

          let tableHeaders = undefined;
          const isNewAdUsersSelected = checkEnableFeatureFlag(enabledFlags, [newAdUsersMetricKey]) && chartSelectorDataType === newAdUsersKey;
          
          const initialSortStatus = isNewAdUsersSelected && !tableSortSelectors[index] 
            ? { sortKey: newAdUsersPerAdsKey, sortType: 'desc' } 
            : tableSortSelectors[index];

          if (isNewAdUsersSelected) {
            tableHeaders = [
              {title: 'Creative Name', key: 'creativeName'}, 
              {title: 'Ad Type', key: 'adType'}, 
              {title: 'Duration', key: 'duration'}, 
              {title: 'New Ad Users', key: newAdUsersKey},
              {
                title: 'Ads',
                key: 'ads',
                icon: (
                  <Tooltip title={ADSICON_TOOLTIP_TEXT}>
                    <InfoIcon className={styles.adsIcon}/>
                  </Tooltip>
                )
              },
              {title: 'New Ad Users/Ads', key: 'newAdUsersPerAds'},
              {title: 'Avg. Ad Cost', key: 'avgAdCost'}
            ];
          }
          return (
            <div 
              key={key}
              className={cx({
                [styles.creativeAnalyticsContainerMainView]: !isCustomReport},
                styles.creativeAnalyticsContainer
              )}
            >
              {isDisplayChartContainer &&
                <div
                  data-test="creativeChart"
                  ref={this.exportContainer}
                  className={cx({[styles.deleteItemContainer]: currentStep === 'customize' && showCreativeChart},
                  {[styles.itemContainer]: isDisplayCreativeChartInPreview})}
                >
                  {showCreativeChart &&
                    <ModuleExport
                      exportImg={this.exportContainer}
                      scrollableChild={this.scrollableChild}
                      fileName={CREATIVE_CHART_FILE_NAME}
                      disableCsvExport
                    />
                  }
                  {showDeleteChartButton &&
                    <DeleteReportItemButton
                      isDelete={showDeleteChartButton}
                      parentId="creative"
                      componentId="creativeChart"
                      customClassName={styles.deleteButton}
                      itemIndex={index}
                    />
                  }
                  <div className={styles.header}>
                    <div>{title}</div>
                  </div>
                  <div className={styles.dropDownBox}>
                    {this.drawDataSelector(index, chartSelectorDataType)}
                    {this.drawCategorySelector(index, chartSelectorCategory)}
                  </div>
                  {showCreativeChart &&
                    <div className={styles.chartContainer}>
                      <div className={styles.chartScroller} ref={this.scrollableChild}>
                        <div className={styles.chart}>
                          <CreativeChart
                            data={chartData}
                            xAxisTitle={chartAxis}
                            isDuration={isDuration}
                            isAvgAdCost={isAvgAdCost}
                            isAdVisit={isAdVisit}
                            isNewAdUsers={isNewAdUsersSelected}
                          />
                        </div>
                      </div>
                      <div className={styles.chartAxis} data-test="creativeChartAxis">{chartAxis}</div>
                      {shouldShowNewAdUserSunsetDisclaimer(
                        campaign,
                        isNewAdUserSelected
                      ) && (
                        <NewAdUserSunsetDisclaimer
                          customStyle={styles.creativeDisclaimer}
                        />
                      )}
                    </div>
                  }
                </div>
              }
              { showCreativeTable &&
                <div className={cx({[styles.deleteItemContainer]: currentStep === 'customize'}, styles.tableContainer, styles.itemContainer)}>
                  {showDeleteTableButton &&
                    <DeleteReportItemButton
                      isDelete={showDeleteTableButton}
                      parentId="creative"
                      componentId="creativeTable"
                      customClassName={styles.deleteButton}
                      itemIndex={index}
                    />
                  }
                  <CreativeTable
                    data={data}
                    isAvgCostDisabled={isAvgCostDisabled}
                    onCellClick={this.handleCellClick}
                    inpdf={inpdf}
                    page={page}
                    numberPage={numberPage}
                    rowsPerPage={rowsPerPage}
                    isGrandTotalDisplay={isGrandTotalDisplay}
                    isCustomReport={isCustomReport}
                    showCreativeChart={isDisplayCreativeChartInPreview}
                    onTableSort={this.onTableSort}
                    initialSortStatus={initialSortStatus}
                    tableIndex={index}
                    tableHeaders={tableHeaders}
                    isNewAdUsersSelected={isNewAdUsersSelected}
                    rowsFirstPage={rowOnFirstPage}
                  />
                </div>
              }
              <ShowAllAds
                open={isDrillDownOpen}
                detailUrl={summaryDrillDownUrl}
                detailInfo={summaryDrillDownInfo}
                onClose={this.handleDrillDownClose}
                campaign={campaign}
                advertiser={advertiser}
                id={CREATIVE_CHART_ID}
                notifications={notifications}
                onAnalyzeMention={this.handleAnalyzeMention}
              />
            </div>
          )
        })}
      </Fragment>
    );
  }
}

const muiStyle = {
  arrowDropDown: {
    color: '#2196f3'
  }
};

import { compose } from 'redux';
import { connect } from 'react-redux';
import { selectVisualRefreshData, reProcessSaga, removeVisualRefreshDataSaga } from '../../../state/modules/app/visualDataRefresh'
import { updateSelectedChartCampaign, undoCreativeName } from '../../../state/modules/app/campaign';
import {
  removeCreativeSaga,
  undoCreativeSaga,
  setChartSelector,
  setTableSortStatus
} from '../../../state/modules/app/campaign';
import getUrlApi from '../../../helpers/getUrlApi';
import { selectCurrentRoutePayload } from '../../../state/modules/routing';
import { redirectToCampaignTabs } from '../../../state/modules/routing/actions';
import { setReportChartSelector } from '../../../state/modules/app/reportBuilder/actions';
import {
  checkEnableFeatureFlag,
  getEnabledFlags,
  shouldShowNewAdUserSunsetDisclaimer,
  shouldShowTileByDateCompare,
} from '../../../helpers/common';

const CreativeAnalyticsSmartComponent = connect(
  (state, props) => {
    const { chartData, campaign } = props;
    const data = get(chartData, [CREATIVE_CHART_ID, 'data'], []);
    const isAvgCostDisabled = get(chartData, 'avgAdCost') == null;
    const visualDataRefresh = selectVisualRefreshData(state);
    const currentData = get(visualDataRefresh, 'currentData', []);
    const selectedDataType = get(campaign, ['chartSelector', CREATIVE_CHART_ID, 'dataType'], defaultDataType);
    const selectedCategoryType = get(campaign, ['chartSelector', CREATIVE_CHART_ID, 'categoryType'], defaultCategoryType);
    const currentStep = get(state, 'reportBuilder.currentStep', '');
    const creativeChartSelectors = props.creativeChartSelectors || get(state, ['reportBuilder', 'chartSelector', CREATIVE_CHART_ID], []);

    return {
      urlApi: getUrlApi(state),
      currentData,
      currentPayload: selectCurrentRoutePayload(state),
      data,
      isAvgCostDisabled,
      selectedDataType,
      selectedCategoryType,
      currentStep,
      creativeChartSelectors,
      tableSortSelectors: props.tableSortSelectors || get(state, ['reportBuilder', 'tableSortSelector', CREATIVE_CHART_ID], {}),
      enabledFlags: getEnabledFlags(props, state),
    }
  },
  dispatch => ({
    redirectToCampaignTabs,
    updateSelected: compose(dispatch, updateSelectedChartCampaign),
    removeCreativeSaga: compose(dispatch, removeCreativeSaga),
    undoCreativeName: compose(dispatch, undoCreativeName),
    undoCreativeSaga: compose(dispatch, undoCreativeSaga),
    reProcessSaga: compose(dispatch, reProcessSaga),
    removeVisualRefreshDataSaga: compose(dispatch, removeVisualRefreshDataSaga),
    setChartSelector: compose(dispatch, setChartSelector),
    setTableSortStatus: compose(dispatch, setTableSortStatus),
    setReportChartSelector: compose(dispatch, setReportChartSelector),
  })
)(withStyles(muiStyle)(CreativeAnalytics));

export default CreativeAnalyticsSmartComponent;
